module.exports = __webpack_public_path__ + "static/media/hero-image-1.e99f25e6.png";